import { Gavel } from '@mui/icons-material';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import React, { Component } from 'react';
import { buamatogColors } from './theme';

class Buamarules extends Component<{}, {}> {   
    render() {     
        const rules = [
            "#1: Im Zweifel oiwä Bier",
            "#2: Du sollst nicht begehren deines nächsten Bier!",
            "#3: Du sollst nicht speiben (ausser man saufe weiter)",
            "#4: Oas hom ma oiwä no trunkn!",
            "#5: Du sollst kein bier verschütten",
            "#6: Leere Gläser sind zu vermeiden",
            "#7: Vermeide die Unterhopfung",
            "#8: Du sollst den Wirt deines Vertrauens stets ehren!",
            "#9: Kropfetzn is da WAHN!",
            "#10: Du sollst den Buamatog heiligen!"
        ];
        
        return (
            <React.Fragment>
                <Box textAlign={'center'}>
                    <Typography textAlign={'center'} variant={'h4'} sx={{ p: 2, paddingBottom: 0 }}>Buamaregeln</Typography>
                    <Typography textAlign={'center'} variant={'body2'} sx={{ p: 2, paddingTop: 0 }}>Um den tog guad z üwasteah hoits ench a de vom buamagott vorgebnen regeln!</Typography>
                </Box>
                <Box flexGrow={1} flexBasis={'400px'} sx={{ p: 2, pt: 0 }}>
                    <List>
                        {rules.map(label => {
                            return <ListItem>
                                <ListItemText primary={label} />
                            </ListItem>;
                        })}
                    </List>
                    <Gavel sx={{ position: 'absolute', width: '85vw', height: '85vw', right: '0', bottom: '0', opacity: '0.1', color: buamatogColors.golden, zIndex: -1 }}/>
                </Box>
            </React.Fragment>
        );
    }
}
export default Buamarules;